import { styled } from "@mui/material";
import { theme } from "styles/themes";

export const BannerContainer = styled("div")(() => ({
  width: "100%",
  height: "32px",
  background: theme.colors.seatBannerTeal,
  cursor: "pointer",
  padding: "10px 20px",
  color: theme.colors.darkSeatBannerTeal,
  fontWeight: 500,
  fontSize: "16px",
  display: "flex",
  alignItems: "center",
  gap: "14px",
}));

export const BoldText = styled("span")(() => ({
  fontWeight: 700,
}));
